import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import ServicesGrid from '@sophocles/views/services/components/ServicesGrid';

function ServiceDefinitionsView(props) {
  const { t } = useTranslation();

  return (
    <AppNav notFullHeight page="services_dashboard_services">
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', px: 2, pb: 1 }}>
        <TitleBar showBackButton title={t('projectServices.services.pageTitle')} />
        <ServicesGrid />
      </Box>
    </AppNav>
  );
}

export default ServiceDefinitionsView;
